// SchoolContext.js
import React, { createContext, useState, useEffect } from "react";

export const SchoolContext = createContext();

export const SchoolProvider = ({ children }) => {
  const [schoolId, setSchoolId] = useState(() => {
    return localStorage.getItem("schoolId") || null;
  });

  useEffect(() => {
    if (schoolId) {
      localStorage.setItem("schoolId", schoolId);
    }
  }, [schoolId]);

  return (
    <SchoolContext.Provider value={{ schoolId, setSchoolId }}>
      {children}
    </SchoolContext.Provider>
  );
};
